export default __webpack_public_path__ + "static/media/joe.fec85950.gif";